/**
 * Pure state-shape builder for useDeleteConfirm — validates the
 * confirmDelete(row, options) call contract and normalizes the entity label
 * shown in the dialog copy, so the hook itself stays a thin state container.
 */

const DEFAULT_ENTITY_LABEL = 'item';

/**
 * @param {unknown} row - the row/record the caller wants deleted; opaque here.
 * @param {{ entityLabel?: string, body?: import('react').ReactNode, onConfirm: (row: unknown) => (Promise<unknown>|unknown) }} options
 * @returns {{ row: unknown, entityLabel: string, body: (import('react').ReactNode|null), onConfirm: Function }}
 */
export function buildPendingDelete(row, options = {}) {
  const { entityLabel, body, onConfirm } = options;

  if (typeof onConfirm !== 'function') {
    throw new Error('useDeleteConfirm: confirmDelete requires an onConfirm function');
  }

  return {
    row,
    entityLabel: typeof entityLabel === 'string' && entityLabel.trim() ? entityLabel : DEFAULT_ENTITY_LABEL,
    body: body ?? null,
    onConfirm,
  };
}
